import { App } from "@common/models";

import { AppContextActionType, SetApp, SetLoading } from "./App.types";

export const setAppAction = (payload: App): SetApp => ({
  type: AppContextActionType.SET_APP,
  payload,
});

export const setLoadingAction = (payload: boolean): SetLoading => ({
  type: AppContextActionType.SET_LOADING,
  payload,
});
